// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"f8e2d755","496":"a80450ba","726":"64e9befd"}[chunkId] + ".chunk.js";
};